var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19944",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 20.9507V16.384L11.3333 14.0673V18.634L15.3333 20.9507ZM16.6667 20.9507L20.6667 18.634V14.0673L16.6667 16.384V20.9507ZM15.3333 22.484L10.6667 19.8007C10.4556 19.6784 10.2917 19.5173 10.175 19.3173C10.0583 19.1173 10 18.8951 10 18.6507V13.3507C10 13.1062 10.0583 12.884 10.175 12.684C10.2917 12.484 10.4556 12.3229 10.6667 12.2007L15.3333 9.51732C15.5444 9.3951 15.7667 9.33398 16 9.33398C16.2333 9.33398 16.4556 9.3951 16.6667 9.51732L21.3333 12.2007C21.5444 12.3229 21.7083 12.484 21.825 12.684C21.9417 12.884 22 13.1062 22 13.3507V18.6507C22 18.8951 21.9417 19.1173 21.825 19.3173C21.7083 19.5173 21.5444 19.6784 21.3333 19.8007L16.6667 22.484C16.4556 22.6062 16.2333 22.6673 16 22.6673C15.7667 22.6673 15.5444 22.6062 15.3333 22.484ZM18.6667 13.684L19.95 12.9507L16 10.6673L14.7 11.4173L18.6667 13.684ZM16 15.234L17.3 14.484L13.35 12.2007L12.05 12.9507L16 15.234Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardboard);
export default __webpack_public_path__ + "static/media/cardboard.a5749730e486b50042d80eebff962394.svg";
export { ForwardRef as ReactComponent };